import { modelRoutes, type TersaImageModel } from '../types';
import { providers } from '../../providers';
import { kie } from '../kie';
import { wavespeed } from '../wavespeed';
import { suchuang } from '../suchuang';
import { grsai } from '../grsai';
import { baidu } from '../baidu';
import { dimensio } from '../dimensio';

// 系数
const COST_FACTOR = 1.5;

export const openaiModels: Record<string, TersaImageModel> = {
    'gpt-image-2.5-flare': {
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: undefined,
                model_create: grsai.image('gpt-image-2.5-flare'),
                modelBackup_create: modelRoutes({
                    other: {
                        '9x21,5x4,4x5,3x1,1x3,2x1,1x2': [suchuang.image('gpt-image-2.5-flare'), wavespeed.image('gpt-image-2.5-flare-text-to-image')],
                        other: [suchuang.image('gpt-image-2.5-flare'), kie.image('gpt-image-2.5-flare'), wavespeed.image('gpt-image-2.5-flare-text-to-image')],
                    },
                }, [suchuang.image('gpt-image-2.5-flare'), kie.image('gpt-image-2.5-flare'), wavespeed.image('gpt-image-2.5-flare-text-to-image')]),
                model_edit: grsai.image('gpt-image-2.5-flare'),
                modelBackup_edit: modelRoutes({
                    other: {
                        '9x21,5x4,4x5,3x1,1x3,2x1,1x2': [suchuang.image('gpt-image-2.5-flare'), wavespeed.image('gpt-image-2.5-flare-edit')],
                        other: [suchuang.image('gpt-image-2.5-flare'), kie.image('gpt-image-2.5-flare'), wavespeed.image('gpt-image-2.5-flare-edit')],
                    },
                }, [suchuang.image('gpt-image-2.5-flare'), kie.image('gpt-image-2.5-flare'), wavespeed.image('gpt-image-2.5-flare-edit')]),
                getCost: ({ mode, providerOptions } = {}) => {
                    const size = typeof providerOptions?.image_resolution === 'string' ? (providerOptions.image_resolution).toUpperCase() : '1K';
                    const quality = typeof providerOptions?.quality === 'string' ? providerOptions.quality : 'medium';
                    if (mode === 'i2i') {
                        if (size === '1K') {
                            if (quality === 'low') return 0.02 * COST_FACTOR;
                            if (quality === 'medium') return 0.034 * COST_FACTOR;
                            if (quality === 'high') return 0.10 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.17 * COST_FACTOR;
                            if (quality === 'max') return 0.37 * COST_FACTOR;
                            return 0.034 * COST_FACTOR;
                        }
                        if (size === '2K') {
                            if (quality === 'low') return 0.03 * COST_FACTOR;
                            if (quality === 'medium') return 0.05 * COST_FACTOR;
                            if (quality === 'high') return 0.16 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.28 * COST_FACTOR;
                            if (quality === 'max') return 0.61 * COST_FACTOR;
                            return 0.05 * COST_FACTOR;
                        }
                        if (size === '4K') {
                            if (quality === 'low') return 0.04 * COST_FACTOR;
                            if (quality === 'medium') return 0.08 * COST_FACTOR;
                            if (quality === 'high') return 0.28 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.49 * COST_FACTOR;
                            if (quality === 'max') return 1.01 * COST_FACTOR;
                            return 0.08 * COST_FACTOR;
                        }
                    }
                    if (size === '1K') {
                        if (quality === 'low') return 0.01 * COST_FACTOR;
                        if (quality === 'medium') return 0.024 * COST_FACTOR;
                        if (quality === 'high') return 0.09 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.16 * COST_FACTOR;
                        if (quality === 'max') return 0.36 * COST_FACTOR;
                        return 0.024 * COST_FACTOR;
                    }
                    if (size === '2K') {
                        if (quality === 'low') return 0.02 * COST_FACTOR;
                        if (quality === 'medium') return 0.04 * COST_FACTOR;
                        if (quality === 'high') return 0.15 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.27 * COST_FACTOR;
                        if (quality === 'max') return 0.60 * COST_FACTOR;
                        return 0.04 * COST_FACTOR;
                    }
                    if (size === '4K') {
                        if (quality === 'low') return 0.03 * COST_FACTOR;
                        if (quality === 'medium') return 0.07 * COST_FACTOR;
                        if (quality === 'high') return 0.27 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.48 * COST_FACTOR;
                        if (quality === 'max') return 1.00 * COST_FACTOR;
                        return 0.07 * COST_FACTOR;
                    }
                    return 0.024 * COST_FACTOR;
                },
                getPassCount: ({ mode, providerOptions } = {}) => {
                    const size = typeof providerOptions?.image_resolution === 'string' ? (providerOptions.image_resolution).toUpperCase() : '1K';
                    const quality = typeof providerOptions?.quality === 'string' ? providerOptions.quality : 'medium';
                    if (mode === 'i2i') {
                        if (size === '1K') {
                            if (quality === 'low') return 0.02 * 100 * COST_FACTOR;
                            if (quality === 'medium') return 0.034 * 100 * COST_FACTOR;
                            if (quality === 'high') return 0.10 * 100 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.17 * 100 * COST_FACTOR;
                            if (quality === 'max') return 0.37 * 100 * COST_FACTOR;
                            return 0.034 * 100 * COST_FACTOR;
                        }
                        if (size === '2K') {
                            if (quality === 'low') return 0.03 * 100 * COST_FACTOR;
                            if (quality === 'medium') return 0.05 * 100 * COST_FACTOR;
                            if (quality === 'high') return 0.16 * 100 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.28 * 100 * COST_FACTOR;
                            if (quality === 'max') return 0.61 * 100 * COST_FACTOR;
                            return 0.05 * 100 * COST_FACTOR;
                        }
                        if (size === '4K') {
                            if (quality === 'low') return 0.04 * 100 * COST_FACTOR;
                            if (quality === 'medium') return 0.08 * 100 * COST_FACTOR;
                            if (quality === 'high') return 0.28 * 100 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.49 * 100 * COST_FACTOR;
                            if (quality === 'max') return 1.01 * 100 * COST_FACTOR;
                            return 0.08 * 100 * COST_FACTOR;
                        }
                    }
                    if (size === '1K') {
                        if (quality === 'low') return 0.01 * 100 * COST_FACTOR;
                        if (quality === 'medium') return 0.024 * 100 * COST_FACTOR;
                        if (quality === 'high') return 0.09 * 100 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.16 * 100 * COST_FACTOR;
                        if (quality === 'max') return 0.36 * 100 * COST_FACTOR;
                        return 0.024 * 100 * COST_FACTOR;
                    }
                    if (size === '2K') {
                        if (quality === 'low') return 0.02 * 100 * COST_FACTOR;
                        if (quality === 'medium') return 0.04 * 100 * COST_FACTOR;
                        if (quality === 'high') return 0.15 * 100 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.27 * 100 * COST_FACTOR;
                        if (quality === 'max') return 0.60 * 100 * COST_FACTOR;
                        return 0.04 * 100 * COST_FACTOR;
                    }
                    if (size === '4K') {
                        if (quality === 'low') return 0.03 * 100 * COST_FACTOR;
                        if (quality === 'medium') return 0.07 * 100 * COST_FACTOR;
                        if (quality === 'high') return 0.27 * 100 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.48 * 100 * COST_FACTOR;
                        if (quality === 'max') return 1.00 * 100 * COST_FACTOR;
                        return 0.07 * 100 * COST_FACTOR;
                    }
                    return 0.024 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K', '4K'],
            },
            i2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 16, maxSize: '30MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'gpt-image-2.5-sunburst': {
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: undefined,
                model_create: grsai.image('gpt-image-2.5-sunburst'),
                modelBackup_create: modelRoutes({
                    other: {
                        '9x21,5x4,4x5,3x1,1x3,2x1,1x2': [suchuang.image('gpt-image-2.5-sunburst'), wavespeed.image('gpt-image-2.5-sunburst-text-to-image')],
                        other: [suchuang.image('gpt-image-2.5-sunburst'), kie.image('gpt-image-2.5-sunburst'), wavespeed.image('gpt-image-2.5-sunburst-text-to-image')],
                    },
                }, [suchuang.image('gpt-image-2.5-sunburst'), kie.image('gpt-image-2.5-sunburst'), wavespeed.image('gpt-image-2.5-sunburst-text-to-image')]),
                model_edit: grsai.image('gpt-image-2.5-sunburst'),
                modelBackup_edit: modelRoutes({
                    other: {
                        '9x21,5x4,4x5,3x1,1x3,2x1,1x2': [suchuang.image('gpt-image-2.5-sunburst'), wavespeed.image('gpt-image-2.5-sunburst-edit')],
                        other: [suchuang.image('gpt-image-2.5-sunburst'), kie.image('gpt-image-2.5-sunburst'), wavespeed.image('gpt-image-2.5-sunburst-edit')],
                    },
                }, [suchuang.image('gpt-image-2.5-sunburst'), kie.image('gpt-image-2.5-sunburst'), wavespeed.image('gpt-image-2.5-sunburst-edit')]),
                getCost: ({ mode, providerOptions } = {}) => {
                    const size = typeof providerOptions?.image_resolution === 'string' ? (providerOptions.image_resolution).toUpperCase() : '1K';
                    const quality = typeof providerOptions?.quality === 'string' ? providerOptions.quality : 'medium';
                    if (mode === 'i2i') {
                        if (size === '1K') {
                            if (quality === 'low') return 0.02 * COST_FACTOR;
                            if (quality === 'medium') return 0.034 * COST_FACTOR;
                            if (quality === 'high') return 0.10 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.17 * COST_FACTOR;
                            if (quality === 'max') return 0.37 * COST_FACTOR;
                            return 0.034 * COST_FACTOR;
                        }
                        if (size === '2K') {
                            if (quality === 'low') return 0.03 * COST_FACTOR;
                            if (quality === 'medium') return 0.05 * COST_FACTOR;
                            if (quality === 'high') return 0.16 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.28 * COST_FACTOR;
                            if (quality === 'max') return 0.61 * COST_FACTOR;
                            return 0.05 * COST_FACTOR;
                        }
                        if (size === '4K') {
                            if (quality === 'low') return 0.04 * COST_FACTOR;
                            if (quality === 'medium') return 0.08 * COST_FACTOR;
                            if (quality === 'high') return 0.28 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.49 * COST_FACTOR;
                            if (quality === 'max') return 1.01 * COST_FACTOR;
                            return 0.08 * COST_FACTOR;
                        }
                    }
                    if (size === '1K') {
                        if (quality === 'low') return 0.01 * COST_FACTOR;
                        if (quality === 'medium') return 0.024 * COST_FACTOR;
                        if (quality === 'high') return 0.09 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.16 * COST_FACTOR;
                        if (quality === 'max') return 0.36 * COST_FACTOR;
                        return 0.024 * COST_FACTOR;
                    }
                    if (size === '2K') {
                        if (quality === 'low') return 0.02 * COST_FACTOR;
                        if (quality === 'medium') return 0.04 * COST_FACTOR;
                        if (quality === 'high') return 0.15 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.27 * COST_FACTOR;
                        if (quality === 'max') return 0.60 * COST_FACTOR;
                        return 0.04 * COST_FACTOR;
                    }
                    if (size === '4K') {
                        if (quality === 'low') return 0.03 * COST_FACTOR;
                        if (quality === 'medium') return 0.07 * COST_FACTOR;
                        if (quality === 'high') return 0.27 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.48 * COST_FACTOR;
                        if (quality === 'max') return 1.00 * COST_FACTOR;
                        return 0.07 * COST_FACTOR;
                    }
                    return 0.024 * COST_FACTOR;
                },
                getPassCount: ({ mode, providerOptions } = {}) => {
                    const size = typeof providerOptions?.image_resolution === 'string' ? (providerOptions.image_resolution).toUpperCase() : '1K';
                    const quality = typeof providerOptions?.quality === 'string' ? providerOptions.quality : 'medium';
                    if (mode === 'i2i') {
                        if (size === '1K') {
                            if (quality === 'low') return 0.02 * 100 * COST_FACTOR;
                            if (quality === 'medium') return 0.034 * 100 * COST_FACTOR;
                            if (quality === 'high') return 0.10 * 100 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.17 * 100 * COST_FACTOR;
                            if (quality === 'max') return 0.37 * 100 * COST_FACTOR;
                            return 0.034 * 100 * COST_FACTOR;
                        }
                        if (size === '2K') {
                            if (quality === 'low') return 0.03 * 100 * COST_FACTOR;
                            if (quality === 'medium') return 0.05 * 100 * COST_FACTOR;
                            if (quality === 'high') return 0.16 * 100 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.28 * 100 * COST_FACTOR;
                            if (quality === 'max') return 0.61 * 100 * COST_FACTOR;
                            return 0.05 * 100 * COST_FACTOR;
                        }
                        if (size === '4K') {
                            if (quality === 'low') return 0.04 * 100 * COST_FACTOR;
                            if (quality === 'medium') return 0.08 * 100 * COST_FACTOR;
                            if (quality === 'high') return 0.28 * 100 * COST_FACTOR;
                            if (quality === 'xhigh') return 0.49 * 100 * COST_FACTOR;
                            if (quality === 'max') return 1.01 * 100 * COST_FACTOR;
                            return 0.08 * 100 * COST_FACTOR;
                        }
                    }
                    if (size === '1K') {
                        if (quality === 'low') return 0.01 * 100 * COST_FACTOR;
                        if (quality === 'medium') return 0.024 * 100 * COST_FACTOR;
                        if (quality === 'high') return 0.09 * 100 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.16 * 100 * COST_FACTOR;
                        if (quality === 'max') return 0.36 * 100 * COST_FACTOR;
                        return 0.024 * 100 * COST_FACTOR;
                    }
                    if (size === '2K') {
                        if (quality === 'low') return 0.02 * 100 * COST_FACTOR;
                        if (quality === 'medium') return 0.04 * 100 * COST_FACTOR;
                        if (quality === 'high') return 0.15 * 100 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.27 * 100 * COST_FACTOR;
                        if (quality === 'max') return 0.60 * 100 * COST_FACTOR;
                        return 0.04 * 100 * COST_FACTOR;
                    }
                    if (size === '4K') {
                        if (quality === 'low') return 0.03 * 100 * COST_FACTOR;
                        if (quality === 'medium') return 0.07 * 100 * COST_FACTOR;
                        if (quality === 'high') return 0.27 * 100 * COST_FACTOR;
                        if (quality === 'xhigh') return 0.48 * 100 * COST_FACTOR;
                        if (quality === 'max') return 1.00 * 100 * COST_FACTOR;
                        return 0.07 * 100 * COST_FACTOR;
                    }
                    return 0.024 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K', '4K'],
            },
            i2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 16, maxSize: '30MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'gpt-image-2.5': {
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: undefined,
                model_create: suchuang.image('gpt-image-2.5'),
                modelBackup_create: [grsai.image('gpt-image-2.5')],
                model_edit: suchuang.image('gpt-image-2.5'),
                modelBackup_edit: [grsai.image('gpt-image-2.5')],
                getCost: () => {
                    return 0.02 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.02 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['1x1', '16x9', '9x16', '21x9', '9x21', '4x3', '3x4', '5x4', '4x5', '3x2', '2x3', '3x1', '1x3', '2x1', '1x2'],
                resolutions: ['1K'],
            },
            i2i: {
                sizes: ['1x1', '16x9', '9x16', '21x9', '9x21', '4x3', '3x4', '5x4', '4x5', '3x2', '2x3', '3x1', '1x3', '2x1', '1x2'],
                resolutions: ['1K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 16, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'gpt-image-2-official': {
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: undefined,
                model_create: grsai.image('gpt-image-2-vip'),
                modelBackup_create: [kie.image('gpt-image-2'), baidu.image('gpt-image-2'), wavespeed.image('gpt-image-2-text-to-image')],
                model_edit: grsai.image('gpt-image-2-vip'),
                modelBackup_edit: [kie.image('gpt-image-2'), baidu.image('gpt-image-2'), wavespeed.image('gpt-image-2-edit')],
                getCost: ({ providerOptions } = {}) => {
                    const size = typeof providerOptions?.image_resolution === 'string' ? (providerOptions.image_resolution).toUpperCase() : '1K';
                    const quality = typeof providerOptions?.quality === 'string' ? providerOptions.quality : 'medium';
                    if (size === '1K') {
                        if (quality === 'low') return (30 / (1000000 / 119) * (COST_FACTOR + 0.5));
                        if (quality === 'medium') return (30 / (1000000 / 1010) * COST_FACTOR);
                        if (quality === 'high') return (30 / (1000000 / 4039) * COST_FACTOR);
                    }
                    if (size === '2K') {
                        if (quality === 'low') return (30 / (1000000 / 348) * (COST_FACTOR + 0.5));
                        if (quality === 'medium') return (30 / (1000000 / 3223) * COST_FACTOR);
                        if (quality === 'high') return (30 / (1000000 / 12890) * COST_FACTOR);
                    }
                    if (size === '4K') {
                        if (quality === 'low') return (30 / (1000000 / 659) * (COST_FACTOR + 0.5));
                        if (quality === 'medium') return (30 / (1000000 / 5930) * COST_FACTOR);
                        if (quality === 'high') return (30 / (1000000 / 23719) * COST_FACTOR);
                    }
                    return (30 / (1000000 / 23719) * COST_FACTOR);
                },
                getPassCount: ({ providerOptions } = {}) => {
                    const size = typeof providerOptions?.image_resolution === 'string' ? (providerOptions.image_resolution).toUpperCase() : '1K';
                    const quality = typeof providerOptions?.quality === 'string' ? providerOptions.quality : 'medium';
                    if (size === '1K') {
                        if (quality === 'low') return (30 / (1000000 / 119) * 100 * (COST_FACTOR + 0.5));
                        if (quality === 'medium') return (30 / (1000000 / 1010) * 100 * COST_FACTOR);
                        if (quality === 'high') return (30 / (1000000 / 4039) * 100 * COST_FACTOR);
                    }
                    if (size === '2K') {
                        if (quality === 'low') return (30 / (1000000 / 348) * 100 * (COST_FACTOR + 0.5));
                        if (quality === 'medium') return (30 / (1000000 / 3223) * 100 * COST_FACTOR);
                        if (quality === 'high') return (30 / (1000000 / 12890) * 100 * COST_FACTOR);
                    }
                    if (size === '4K') {
                        if (quality === 'low') return (30 / (1000000 / 659) * 100 * (COST_FACTOR + 0.5));
                        if (quality === 'medium') return (30 / (1000000 / 5930) * 100 * COST_FACTOR);
                        if (quality === 'high') return (30 / (1000000 / 23719) * 100 * COST_FACTOR);
                    }
                    return (30 / (1000000 / 23719) * 100 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K', '4K'],
            },
            i2i: {
                sizes: ['match', '21x9', '9x21', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 16, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'gpt-image-2': {
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: undefined,
                model_create: suchuang.image('gpt-image-2'),
                modelBackup_create: [dimensio.image('vxp-gpt-image-2'), grsai.image('gpt-image-2'), kie.image('gpt-image-2'), baidu.image('gpt-image-2')],
                model_edit: suchuang.image('gpt-image-2'),
                modelBackup_edit: [dimensio.image('vxp-gpt-image-2'), grsai.image('gpt-image-2'), kie.image('gpt-image-2'), baidu.image('gpt-image-2')],
                getCost: () => {
                    return 0.04 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.04 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '4x3', '3x4', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K'],
            },
            i2i: {
                sizes: ['match', '21x9', '9x21', '16x9', '9x16', '4x3', '3x4', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 16, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: '6 credits',
    },
    'gpt-image-1.5': {
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: undefined,
                model_create: kie.image('gpt-image-1.5'),
                modelBackup_create: [wavespeed.image('gpt-image-1.5-text-to-image')],
                model_edit: kie.image('gpt-image-1.5'),
                modelBackup_edit: [wavespeed.image('gpt-image-1.5-edit')],
                getCost: () => {
                    return 0.1 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.1 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                    video: { allow: false, maxCount: 0, maxSize: '0' },
                    audio: { allow: false, maxCount: 0, maxSize: '0' },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'gpt-image-1': {
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: undefined,
                model_create: wavespeed.image('gpt-image-1-text-to-image'),
                model_edit: wavespeed.image('gpt-image-1-edit'),
                getCost: () => {
                    return 0.042 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.042 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'gpt-image-1-mini': {
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: undefined,
                model_create: wavespeed.image('gpt-image-1-mini-text-to-image'),
                model_edit: wavespeed.image('gpt-image-1-mini-edit'),
                getCost: () => {
                    return 0.02 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.02 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: [],
                resolutions: [],
            },
            i2i: {
                sizes: [],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};